(() => {
  /**
   * AUTO-AVAILABILITY BY SIZE (Shopify faceted filters)
   * - Se selezioni una Taglia/Size nei filtri:
   *   1) prova ad attivare anche "Disponibilità: Disponibile"
   *   2) nasconde le card dei prodotti che NON hanno quella taglia disponibile
   *
   * Nota: è una pezza lato frontend (non cambia URL / SEO).
   */

  // ---- CONFIG
  const SIZE_FIELD_HINTS = ["taglia", "size"]; // se il tuo filtro taglie ha altri nomi, aggiungili qui
  const PRODUCT_LINK_SELECTOR = 'a[href*="/products/"]';

  // Cache prodotti per non martellare /products/handle.js
  const productCache = new Map(); // handle -> productJson | null
  const pendingFetches = new Map(); // handle -> Promise

  function norm(s) {
    return String(s || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function isSizeFilterInput(input) {
    if (!input) return false;

    // Shopify di solito usa name tipo: filter.v.option.taglia / filter.v.option.size ecc.
    const name = (input.getAttribute("name") || "").toLowerCase();
    if (!name.startsWith("filter.")) return false;
    if (!name.includes("option.")) return false;

    return SIZE_FIELD_HINTS.some((h) => name.includes("." + h) || name.includes(h));
  }

  function getSelectedSizesFromUI() {
  // 1) Checkbox (desktop + tanti temi)
  const checked = Array.from(
    document.querySelectorAll('input[type="checkbox"][name^="filter."]:checked')
  );

  let selected = checked
    .filter(isSizeFilterInput)
    .map((i) => i.value)
    .filter(Boolean)
    .map(norm);

  // 2) Fallback: parametri URL (mobile drawer / UI “strana”)
  try {
    const params = new URLSearchParams(window.location.search);

    for (const [key, value] of params.entries()) {
      const k = (key || "").toLowerCase();
      const isSizeKey =
        k.startsWith("filter.") &&
        k.includes("option.") &&
        SIZE_FIELD_HINTS.some((h) => k.includes("." + h) || k.includes(h));

      if (isSizeKey && value) selected.push(norm(value));
    }
  } catch (e) {}

  return Array.from(new Set(selected));
}


  function findProductCards() {
    // Provo a prendere le card in modo robusto:
    // - elementi che contengono un link a /products/
    const links = Array.from(document.querySelectorAll(PRODUCT_LINK_SELECTOR));

    const cards = [];
    for (const a of links) {
      const href = a.getAttribute("href") || "";
      const handle = extractHandleFromHref(href);
      if (!handle) continue;

      const cardEl =
        a.closest("[data-product-id]") ||
        a.closest(".product-grid__item") ||
        a.closest(".grid__item") ||
        a.closest(".product-grid-item") ||
        a.closest(".product-card") ||
        a.closest(".card") ||
        a.closest("li") ||
        a;

      // Evito duplicati per handle+card
      cards.push({ handle, el: a, cardEl });
    }

    // Dedup (stesso handle può apparire più volte con link diversi nella stessa card)
    const seen = new Set();
    const unique = [];
    for (const c of cards) {
      const key = c.handle + "::" + (c.cardEl ? c.cardEl.dataset?.productId || "" : "");
      if (seen.has(key)) continue;
      seen.add(key);
      unique.push(c);
    }
    return unique;
  }

  function extractHandleFromHref(href) {
    try {
      // href può essere relativo o assoluto
      const u = href.startsWith("http") ? new URL(href) : new URL(href, location.origin);
      const p = u.pathname;
      const idx = p.indexOf("/products/");
      if (idx === -1) return null;
      const rest = p.slice(idx + "/products/".length);
      const handle = rest.split("/")[0];
      return handle ? handle.trim() : null;
    } catch (e) {
      // fallback super grezzo
      const s = String(href || "");
      const idx = s.indexOf("/products/");
      if (idx === -1) return null;
      return s.slice(idx + 10).split(/[/?#]/)[0] || null;
    }
  }

  function getAvailabilityInput() {
    return document.querySelector(
      'input[name="filter.v.availability"][value="1"], input[name="filter.p.availability"][value="1"], input[name="filter.availability"][value="1"]'
    );
  }

  function ensureAvailabilityOn() {
    const avail = getAvailabilityInput();
    if (!avail) return;

    if (!avail.checked) {
      avail.checked = true;
      avail.dispatchEvent(new Event("change", { bubbles: true }));

      // Alcuni temi richiedono submit del form
      const form = avail.closest("form");
      if (form && typeof form.requestSubmit === "function") form.requestSubmit();
      else if (form) form.submit();
    }
  }

  async function fetchProductJson(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);

    if (pendingFetches.has(handle)) return pendingFetches.get(handle);

    const p = (async () => {
      try {
        const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
        if (!res.ok) throw new Error("fetch failed");
        const json = await res.json();
        productCache.set(handle, json);
        return json;
      } catch (e) {
        productCache.set(handle, null);
        return null;
      } finally {
        pendingFetches.delete(handle);
      }
    })();

    pendingFetches.set(handle, p);
    return p;
  }

  function variantHasSelectedSizeAvailable(product, selectedSizes) {
    if (!product || !Array.isArray(product.variants) || !selectedSizes.length) return true;

    // Match su option1/2/3
    return product.variants.some((v) => {
      if (!v || !v.available) return false;

      const opts = [v.option1, v.option2, v.option3].map(norm);
      return selectedSizes.some((s) => opts.includes(s));
    });
  }

  function showAll(cards) {
    for (const c of cards) {
      if (c.cardEl) {
        c.cardEl.style.display = "";
        c.cardEl.removeAttribute("aria-hidden");
      }
    }
  }

  async function applyAutoAvailabilityBySize() {
    const selectedSizes = getSelectedSizesFromUI();
    const cards = findProductCards();

    // Se non c’è filtro taglia, non faccio nulla (e resetto)
    if (!selectedSizes.length) {
      showAll(cards);
      return;
    }

    // Provo anche ad attivare "Disponibilità" (se esiste)
    ensureAvailabilityOn();

    // Reset visibilità prima di filtrare
    showAll(cards);

    // Filtra: nascondo l’INTERA CARD se NON ha la taglia selezionata disponibile
    for (const { handle, cardEl } of cards) {
      const product = await fetchProductJson(handle);
      if (!product) continue;

      const ok = variantHasSelectedSizeAvailable(product, selectedSizes);
      if (!ok && cardEl) {
        cardEl.style.display = "none";
        cardEl.setAttribute("aria-hidden", "true");
      }
    }
  }

  function debounce(fn, ms) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  }

  const run = debounce(applyAutoAvailabilityBySize, 200);

  // Run iniziale
  document.addEventListener("DOMContentLoaded", run);

  // Quando cambi filtri (facets)
  document.addEventListener(
    "change",
    (e) => {
      // se cambia qualcosa dentro un form di filtri, rilancio
      if (e.target && e.target.closest && e.target.closest("form")) {
        run();
      }
    },
    true
  );

  // Se il tema aggiorna via ajax e cambia URL (popstate)
  window.addEventListener("popstate", run);

  // Shopify editor events
  document.addEventListener("shopify:section:load", run);
  document.addEventListener("shopify:section:reorder", run);

  // MutationObserver per quando il tema rimpiazza la griglia prodotti
  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
